import { PERMISSIONS } from './constants.js';

const SALES_REP_PERMISSIONS = [
    PERMISSIONS.view_only_notes,
    PERMISSIONS.view_only_collection_title,
    PERMISSIONS.view_only_print_type,
    PERMISSIONS.view_only_toc_numeration,
    PERMISSIONS.view_only_print_book_price,
    PERMISSIONS.view_only_page_numbering,
    PERMISSIONS.view_only_automated_indexes,
    PERMISSIONS.view_only_forced_recto,
    PERMISSIONS.view_only_binding_type,
    PERMISSIONS.view_only_paper_type,
    PERMISSIONS.view_only_paper_weight,
    PERMISSIONS.view_only_instructor_change,
    PERMISSIONS.view_only_institution_change,
    PERMISSIONS.view_only_desk_copies,
    PERMISSIONS.view_only_institute,
    PERMISSIONS.view_only_department,
    PERMISSIONS.view_only_instructor,
    PERMISSIONS.view_only_instructor2,
    PERMISSIONS.view_only_address1,
    PERMISSIONS.view_only_address2,
    PERMISSIONS.view_only_address3,
    PERMISSIONS.view_only_city,
    PERMISSIONS.view_only_zip_code,
    PERMISSIONS.view_only_country,
    PERMISSIONS.view_only_state,
    PERMISSIONS.view_only_org_unit,
    PERMISSIONS.view_only_course_name,
    PERMISSIONS.view_only_course_number,
    PERMISSIONS.view_only_term,
    PERMISSIONS.view_only_class_startdate,
    PERMISSIONS.view_only_add_frontmatter,
    PERMISSIONS.hide_add_om,
    PERMISSIONS.hide_add_content,
    PERMISSIONS.view_only_page_divider,
    PERMISSIONS.view_only_delete_chapter,
    PERMISSIONS.view_only_draggable,
    PERMISSIONS.view_only_table_draggable,
    PERMISSIONS.view_only_om_title,
    PERMISSIONS.view_only_om_download,
    PERMISSIONS.view_only_rebuild_book,
    PERMISSIONS.view_only_save_changes,
    PERMISSIONS.view_only_send_to_pdh,
    PERMISSIONS.view_only_view_pdh_log,
    PERMISSIONS.view_only_send_to_pitstop,
    PERMISSIONS.view_only_send_to_printer,
    PERMISSIONS.view_only_cancel_order,
    PERMISSIONS.view_only_bundle_add,
    PERMISSIONS.view_only_bundle_isbn,
    PERMISSIONS.view_only_bundle_notes,
    PERMISSIONS.view_only_cover_title,
    PERMISSIONS.view_only_cover_subtitle,
    PERMISSIONS.view_only_cover_author,
    PERMISSIONS.view_only_cover_other,
    PERMISSIONS.view_only_cover_design,
    PERMISSIONS.view_only_delete_part,
    PERMISSIONS.hide_adding_part,
    PERMISSIONS.view_only_part_title,
    PERMISSIONS.hide_only_pdflinks,
];

const LSA_PREMISSIONS = [];

const PROJECT_SPECIALIST_PERMISSIONS = [];

export const ROLE_PERMISSIONS = {
    project_specialist : PROJECT_SPECIALIST_PERMISSIONS,
    lsa : LSA_PREMISSIONS,
    sales_rep : SALES_REP_PERMISSIONS
};



// WEBPACK FOOTER //
// ./src/components/constants/permissionsConstants.js